import { remove } from "lodash";

const key = "change-exports";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);
	remove(role.Actions, a => a.Path.indexOf("exports") > -1);

	// const newDeny = { Effect: "Deny", Path: "/exports/nightly/logs/*" };
	// const newAllow = { Effect: "Allow", Path: "/exports/state/logs/*" };

	const newAllow = { Effect: "Allow", Path: "/exports/**/*" };

	role.Actions.push(newAllow);

};

export const changeExports = [key, applicable, modify];